import { IIconStyles } from '@fluentui/react';
import { baseColors } from '../../../../../theme';

export const iconStyles: IIconStyles = {
  root: {
    color: `${baseColors.midOrange} !important`,
  },
};
